import Travel from './Travel'
export default Travel